/* TONA - MARQUESINA (PR-13 · PR-99 21/09) · el comportamiento de la barra de anuncios.
 *
 * Estaba adentro de sections/tona-scrolling-banner.liquid. Se sacó acá con el PR-99 porque
 * ahora lo usan DOS secciones (la marquesina y «Tona - Cuenta regresiva») y dos copias del
 * mismo código divergen en la primera corrección.
 *
 * Tiene dos modos y el elemento elige por `data-modo`:
 *
 * CORRE (lo de siempre, no cambió nada). La pista mide lo que mide su contenido; el JS copia
 * el grupo hasta que media pista cubre la pantalla y la mueve hasta -50%, así el reinicio cae
 * justo donde empezó y no se ve el salto. La duración sale del ancho real, para que los
 * píxeles por segundo sean los mismos en un celular y en un monitor.
 *
 * QUIETA (nuevo). Los mensajes no corren: se muestran de a tandas y se turnan. Las tandas se
 * arman con los mensajes que SE VEN EN ESTE ANCHO —uno apagado en celular no ocupa lugar en
 * una tanda de celular— y la última no se rellena con repetidos. Con una sola tanda no se
 * dibujan ni las flechitas ni los puntitos ni corre el reloj: un control que no hace nada es
 * peor que no tenerlo.
 *
 * Sin JavaScript se ve la primera tanda (la corta el CSS con nth-child) y nada se rompe.
 * Con `prefers-reduced-motion` no hay turno automático ni animación de cambio, pero las
 * flechitas siguen andando.
 */
(function () {
  if (!window.customElements || window.customElements.get('tona-scrolling-banner')) return;

  var COMPU = '(min-width: 750px)';

  class TonaScrollingBanner extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;

      /* ⚠️ Si el elemento se sube (upgrade) MIENTRAS el navegador todavía está leyendo la
         página, sus hijos no existen todavía y querySelector devuelve null: la barra queda
         muerta, sin un solo error en consola. Pasa con dos barras en la misma página, porque
         para la segunda la clase ya está definida cuando aparece la etiqueta de apertura.
         Con los <script defer> del tema no pasa, pero no se depende de eso. */
      if (!this.querySelector('.tona-sb__pista, .tona-sb__quieta')) {
        if (document.readyState === 'loading') {
          var self0 = this;
          document.addEventListener('DOMContentLoaded', function () { self0.connectedCallback(); }, { once: true });
        }
        return;
      }
      this.iniciado = true;
      this.raiz = this.closest('[data-tona-barra]') || this.parentElement;
      this.modo = this.getAttribute('data-modo') === 'quieta' ? 'quieta' : 'corre';
      this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.compu = window.matchMedia(COMPU);

      this.alCambiarCuenta = this.alCambiarCuenta.bind(this);
      document.addEventListener('tona:cuenta-cambio', this.alCambiarCuenta);

      if (this.modo === 'quieta') this.arrancarQuieta();
      else this.arrancarCorre();
    }

    disconnectedCallback() {
      document.removeEventListener('tona:cuenta-cambio', this.alCambiarCuenta);
      if (this.observador) this.observador.disconnect();
      window.removeEventListener('resize', this.programar);
      if (this.reducido && this.reducido.removeEventListener && this.programar) {
        this.reducido.removeEventListener('change', this.programar);
      }
      if (this.compu && this.compu.removeEventListener && this.rearmar) {
        this.compu.removeEventListener('change', this.rearmar);
      }
      cancelAnimationFrame(this.cuadro);
      clearTimeout(this.turno);
      clearTimeout(this.limpiarSalida);
    }

    alCambiarCuenta() {
      if (this.modo === 'quieta') this.rearmar();
      else if (this.programar) this.programar();
    }

    /* ------------------------------------------------------------------ CORRE */

    arrancarCorre() {
      this.pista = this.querySelector('.tona-sb__pista');
      this.grupo = this.querySelector('.tona-sb__grupo');
      if (!this.pista || !this.grupo) return;

      this.velocidad = parseFloat(this.getAttribute('data-velocidad')) || 16;
      this.duracion = 0;
      this.medir = this.medir.bind(this);
      this.programar = this.programar.bind(this);

      if (this.reducido.addEventListener) this.reducido.addEventListener('change', this.programar);

      if ('ResizeObserver' in window) {
        this.observador = new ResizeObserver(this.programar);
        this.observador.observe(this);
        this.observador.observe(this.grupo);
      } else {
        window.addEventListener('resize', this.programar);
      }

      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.programar);
      this.medir();
    }

    programar() {
      cancelAnimationFrame(this.cuadro);
      this.cuadro = requestAnimationFrame(this.medir);
    }

    copias() {
      return this.pista.querySelectorAll('.tona-sb__grupo--copia');
    }

    quieta() {
      this.pista.classList.remove('is-animada');
      this.classList.remove('is-animada');
      this.copias().forEach(function (copia) { copia.remove(); });
      this.duracion = 0;
    }

    medir() {
      var ancho = this.clientWidth;
      var grupo = this.grupo.getBoundingClientRect().width;

      /* Oculta en este ancho (display:none) o todavía sin medida: no se hace nada */
      if (!ancho || !grupo) return;

      if (this.reducido.matches) {
        this.quieta();
        return;
      }

      /* Media pista tiene que cubrir la pantalla entera: k grupos por mitad, 2k en total */
      var k = Math.max(1, Math.ceil(ancho / grupo));
      var faltan = 2 * k - 1 - this.copias().length;

      for (var i = 0; i < faltan; i++) {
        var copia = this.grupo.cloneNode(true);
        copia.classList.add('tona-sb__grupo--copia');
        copia.setAttribute('aria-hidden', 'true');
        copia.removeAttribute('data-shopify-editor-block');
        copia.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
          el.removeAttribute('data-shopify-editor-block');
        });
        copia.querySelectorAll('a').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
        this.pista.appendChild(copia);
      }

      var sobran = this.copias();
      for (var j = sobran.length - 1; j >= 2 * k - 1; j--) sobran[j].remove();

      /* Las cuentas regresivas recién copiadas tienen que arrancar con la hora buena */
      if (faltan > 0 && window.tonaCuenta) window.tonaCuenta.reescanear();

      /* Distancia de una vuelta = media pista = k grupos. Duración = distancia / velocidad */
      var duracion = (k * grupo) / this.velocidad;
      if (Math.abs(duracion - this.duracion) > this.duracion * 0.005) {
        this.duracion = duracion;
        this.pista.style.setProperty('--tona-sb-duracion', duracion.toFixed(3) + 's');
      }

      this.classList.add('is-animada');
      this.pista.classList.add('is-animada');
    }

    /* ----------------------------------------------------------------- QUIETA */

    arrancarQuieta() {
      this.carrusel = this.querySelector('.tona-sb__carrusel');
      var semilla = this.querySelector('.tona-sb__tanda');
      if (!this.carrusel || !semilla) return;

      this.items = Array.prototype.slice.call(semilla.querySelectorAll('.tona-sb__item'));
      this.porCompu = Math.max(1, parseInt(this.getAttribute('data-por-compu'), 10) || 3);
      this.porCel = Math.max(1, parseInt(this.getAttribute('data-por-cel'), 10) || 1);
      this.auto = this.getAttribute('data-auto') === '1';
      this.segundos = Math.max(2, parseInt(this.getAttribute('data-segundos'), 10) || 5);
      this.actual = 0;
      this.pausado = false;
      this.tandas = [];

      this.deposito = document.createElement('div');
      this.deposito.className = 'tona-sb__deposito';
      this.deposito.hidden = true;
      this.carrusel.appendChild(this.deposito);

      this.puntitos = this.querySelector('.tona-sb__puntitos');
      this.rearmar = this.rearmar.bind(this);
      this.programarTurno = this.programarTurno.bind(this);

      var self = this;
      this.querySelectorAll('.tona-sb__flecha').forEach(function (b) {
        b.addEventListener('click', function () {
          self.ir(self.actual + (b.classList.contains('tona-sb__flecha--ant') ? -1 : 1), true);
          /* Tocar una flechita frena el turno automático y lo vuelve a arrancar desde cero */
          self.programarTurno();
        });
      });

      /* El turno se frena mientras alguien está mirando o tabulando adentro */
      this.addEventListener('mouseenter', function () { self.pausado = true; self.programarTurno(); });
      this.addEventListener('mouseleave', function () { self.pausado = false; self.programarTurno(); });
      this.addEventListener('focusin', function () { self.pausado = true; self.programarTurno(); });
      this.addEventListener('focusout', function () { self.pausado = false; self.programarTurno(); });
      document.addEventListener('visibilitychange', this.programarTurno);

      if (this.compu.addEventListener) this.compu.addEventListener('change', this.rearmar);
      else if (this.compu.addListener) this.compu.addListener(this.rearmar);
      if (this.reducido.addEventListener) this.reducido.addEventListener('change', this.programarTurno);

      /* El editor: al elegir un bloque, saltar a la tanda donde está */
      document.addEventListener('shopify:block:select', function (ev) {
        var item = ev.target.closest ? ev.target.closest('.tona-sb__item') : null;
        if (!item || !self.contains(item)) return;
        for (var i = 0; i < self.tandas.length; i++) {
          if (self.tandas[i].contains(item)) { self.ir(i, false); break; }
        }
      });

      this.rearmar();
      if (this.raiz) this.raiz.classList.add('is-viva');
    }

    rearmar() {
      var enCompu = this.compu.matches;
      var por = enCompu ? this.porCompu : this.porCel;
      var fuera = enCompu ? 'tona-sb__item--sin-escritorio' : 'tona-sb__item--sin-celular';

      var visibles = this.items.filter(function (it) {
        return !it.classList.contains(fuera) && !it.hasAttribute('hidden');
      });

      var viejas = Array.prototype.slice.call(this.carrusel.querySelectorAll('.tona-sb__tanda'));
      var nuevas = [];
      for (var i = 0; i < visibles.length; i += por) {
        var tanda = document.createElement('div');
        tanda.className = 'tona-sb__tanda';
        var grupo = visibles.slice(i, i + por);
        for (var k = 0; k < grupo.length; k++) {
          grupo[k].classList.toggle('is-ultimo', k === grupo.length - 1);
          tanda.appendChild(grupo[k]);
        }
        nuevas.push(tanda);
      }
      if (!nuevas.length) {
        var vacia = document.createElement('div');
        vacia.className = 'tona-sb__tanda';
        nuevas.push(vacia);
      }

      /* Los que no se ven en este ancho quedan guardados, para cuando se gire el teléfono */
      var self = this;
      this.items.forEach(function (it) {
        if (visibles.indexOf(it) === -1) self.deposito.appendChild(it);
      });

      nuevas.forEach(function (t) { self.carrusel.appendChild(t); });
      viejas.forEach(function (v) { if (nuevas.indexOf(v) === -1) v.remove(); });

      this.tandas = nuevas;
      this.dibujarPuntitos();
      if (this.raiz) this.raiz.classList.toggle('is-una-sola', this.tandas.length < 2);
      if (this.actual >= this.tandas.length) this.actual = 0;
      this.ir(this.actual, false);
      this.programarTurno();
    }

    dibujarPuntitos() {
      if (!this.puntitos) return;
      var self = this;
      while (this.puntitos.firstChild) this.puntitos.removeChild(this.puntitos.firstChild);
      if (this.tandas.length < 2) return;
      this.tandas.forEach(function (t, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tona-sb__puntito';
        b.setAttribute('aria-label', 'Mostrar el grupo ' + (i + 1) + ' de ' + self.tandas.length);
        b.addEventListener('click', function () { self.ir(i, true); self.programarTurno(); });
        self.puntitos.appendChild(b);
      });
    }

    ir(i, animar) {
      var n = this.tandas.length;
      if (!n) return;
      var destino = ((i % n) + n) % n;
      var haciaAdelante = destino !== this.actual ? (destino > this.actual || (this.actual === n - 1 && destino === 0) ? 1 : -1) : 1;
      var previa = this.tandas[this.actual];

      this.carrusel.style.setProperty('--tona-sb-dir', haciaAdelante);
      this.actual = destino;

      var self = this;
      clearTimeout(this.limpiarSalida);
      this.tandas.forEach(function (t, k) {
        t.classList.remove('is-saliendo');
        t.classList.toggle('is-activa', k === destino);
        t.setAttribute('aria-hidden', k === destino ? 'false' : 'true');
      });
      if (animar && previa && previa !== this.tandas[destino]) {
        previa.classList.add('is-saliendo');
        this.limpiarSalida = setTimeout(function () { previa.classList.remove('is-saliendo'); }, 600);
      }

      if (this.puntitos) {
        Array.prototype.forEach.call(this.puntitos.children, function (b, k) {
          b.classList.toggle('is-activo', k === destino);
          b.setAttribute('aria-current', k === destino ? 'true' : 'false');
        });
      }
      /* Las flechitas de las puntas nunca se apagan: la vuelta es circular */
    }

    programarTurno() {
      clearTimeout(this.turno);
      if (!this.auto) return;
      if (this.tandas.length < 2) return;
      if (this.reducido.matches) return;
      if (this.pausado || document.hidden) return;
      var self = this;
      this.turno = setTimeout(function () {
        self.ir(self.actual + 1, true);
        self.programarTurno();
      }, this.segundos * 1000);
    }
  }

  window.customElements.define('tona-scrolling-banner', TonaScrollingBanner);
})();
